import {createContext} from 'react';

import {ENABLEMENT_GROUP_LABEL} from './treeData';
import type {TreeItem} from './treeTypes';

/**
 * Ids of the "top set" leadership tracks: pillar workstreams and level 2 (A1,
 * B2, T1, …). Cards in it flag a missing north star. Null when the host has no
 * company tree, so nothing is flagged.
 */
export const ScanCoreWorkstreamsContext = createContext<ReadonlySet<number> | null>(null);

const sameName = (a: string, b: string) => a.trim().toLowerCase() === b.trim().toLowerCase();

// The nav nodes carry no level, so read it off the tree's shape: a pillar
// group's children are level 2, except a child named like its pillar (the
// pillar workstream some pillars keep for their own update), whose children
// are level 2 instead. Mirrors helpers/workstream_pillar_metadata.py.
export const getCoreWorkstreamIds = (roots: TreeItem[]): ReadonlySet<number> => {
  const ids = new Set<number>();
  for (const group of roots) {
    if (!group.node.isPillarGroup || group.node.name === ENABLEMENT_GROUP_LABEL) continue;
    for (const child of group.children) {
      ids.add(child.node.id);
      if (!sameName(child.node.name, group.node.name)) continue;
      for (const grandchild of child.children) ids.add(grandchild.node.id);
    }
  }
  return ids;
};
